<button
  mat-icon-button
  (click)="toggleDarkTheme()"
  [matTooltip]="this.isDark ? 'Light Mode' : 'Dark Mode'"
>
  <mat-icon class="mat-18">{{ isDark ? "dark_mode" : "light_mode" }}</mat-icon>
</button>
